import {
  Glass,
  PillChip,
  ScreenLabel,
  DisplayText,
  BodyText,
} from "../../components/mobile/primitives";

function JourneyChatScreen() {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      {/* Header */}
      <div
        style={{
          padding: "8px 16px 6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexShrink: 0,
        }}
      >
        <DisplayText size={18}>Kin</DisplayText>
        <PillChip active color="var(--color-kin-lavender)">
          Sleep Deep Dive
        </PillChip>
      </div>

      {/* Messages */}
      <div
        style={{
          flex: 1,
          padding: "0 12px",
          display: "flex",
          flexDirection: "column",
          gap: 7,
          overflowY: "hidden",
        }}
      >
        {/* User */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              maxWidth: "75%",
              background: "rgba(254,253,251,0.82)",
              border: "1px solid rgba(255,255,255,0.52)",
              borderRadius: "20px 20px 6px 20px",
              padding: "10px 14px",
            }}
          >
            <BodyText size={10} color="var(--color-kin-black)">
              What's the main takeaway from my sleep data?
            </BodyText>
          </div>
        </div>

        {/* AI */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              maxWidth: "88%",
              background: "linear-gradient(135deg, rgba(165,144,255,0.11), rgba(165,144,255,0.05))",
              border: "1px solid rgba(165,144,255,0.20)",
              borderRadius: "6px 20px 20px 20px",
              padding: "12px 14px",
            }}
          >
            <BodyText
              size={10}
              color="var(--color-kin-black)"
              weight={500}
              style={{ lineHeight: 1.5 }}
            >
              Your sleep duration is solid at 7.4h avg, but consistency is the real lever. Nights
              where you kept a regular bedtime showed 12% higher HRV.
            </BodyText>
            <div style={{ display: "flex", gap: 5, marginTop: 6 }}>
              <PillChip active color="var(--color-kin-green-soft)">
                Improving
              </PillChip>
              <PillChip active color="var(--color-kin-lavender)">
                HRV linked
              </PillChip>
            </div>
          </div>
        </div>

        {/* User */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              maxWidth: "75%",
              background: "rgba(254,253,251,0.82)",
              border: "1px solid rgba(255,255,255,0.52)",
              borderRadius: "20px 20px 6px 20px",
              padding: "10px 14px",
            }}
          >
            <BodyText size={10} color="var(--color-kin-black)">
              How do I fix the afternoon energy crash?
            </BodyText>
          </div>
        </div>

        {/* AI with evidence */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              maxWidth: "90%",
              background: "linear-gradient(135deg, rgba(165,144,255,0.11), rgba(165,144,255,0.05))",
              border: "1px solid rgba(165,144,255,0.20)",
              borderRadius: "6px 20px 20px 20px",
              padding: "12px 14px",
            }}
          >
            <BodyText
              size={10}
              color="var(--color-kin-black)"
              weight={500}
              style={{ lineHeight: 1.5 }}
            >
              Your dips cluster on days with irregular meal timing and late caffeine. Sleep is
              improving, but this pattern needs one week of food context to confirm.
            </BodyText>
            <div
              style={{
                background: "rgba(255,255,255,0.65)",
                border: "1px solid rgba(0,0,0,0.06)",
                borderRadius: 10,
                padding: "6px 8px",
                marginTop: 6,
              }}
            >
              <ScreenLabel style={{ marginBottom: 3, display: "block" }}>
                Suggested next step
              </ScreenLabel>
              <BodyText size={9} color="var(--color-kin-black)" weight={500}>
                Track meals + caffeine for 7 days, then reassess energy dips.
              </BodyText>
            </div>
          </div>
        </div>
      </div>

      {/* Input */}
      <div style={{ padding: "6px 12px 0", flexShrink: 0 }}>
        <Glass
          style={{
            padding: "8px 10px 8px 16px",
            display: "flex",
            alignItems: "center",
            gap: 8,
            borderRadius: 28,
          }}
        >
          <BodyText size={10} color="var(--color-kin-muted)" weight={500}>
            Ask about your health…
          </BodyText>
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              background: "var(--color-kin-green-soft)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              marginLeft: "auto",
            }}
          >
            <span style={{ color: "#fff", fontSize: 13, fontWeight: 700, lineHeight: 1 }}>↑</span>
          </div>
        </Glass>
      </div>
    </div>
  );
}

export { JourneyChatScreen };
